import { CommonModule } from '@angular/common'
import {} from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
// import { SocketIoModule } from 'ngx-socket-io'
import { DevBarComponent } from './components/dev-bar/dev-bar.component.js'
import { FileUploadComponent } from './components/file-upload/file-upload.component.js'
import { GenericPopupComponent } from './components/generic-popup/generic-popup.component.js'
import { ValidationErrorsComponent } from './components/validation-errors.component.js'
// import { VideoComponent } from './components/video/video.component.js'
import { FormDirective } from './directives/form.directive.js'
import { ScopeDirective } from './directives/scope.directive.js'
import { MaterialModules } from './material.modules.js'
import { Base64SrcPipe } from './pipes/base64-src.pipe.js'
// import { FormBindingPipe } from './pipes/form-binding.pipe.js'
import { SafeHtmlPipe } from './pipes/safe-html.pipe.js'
import { SafeResourceUrlPipe } from './pipes/safe-resource-url.pipe.js'
import { SafeUrlPipe } from './pipes/safe-url.pipe.js'
import { LetDirective } from '@ngrx/component'
import { OverlayModule } from '@angular/cdk/overlay'
import { UntilChangedPipe } from './pipes/until-changed.pipe.js'
import { SearchableDropdownComponent } from './components/searchable-dropdown/searchable-dropdown.component.js'
import { GenericTableComponent } from './components/generic-table/generic-table.component.js'
import { DynamicTabDirective } from './directives/dynamic-tab.directive.js'
import { AngularSplitModule } from 'angular-split'
import { ConstPipe } from './pipes/const.pipe.js'
import { JsonHighlightPipe } from './pipes/json-highlight.pipe.js'
import { SnackBarComponent } from './components/snack-bar/snack-bar.component.js'
import { FormFieldDirective } from './directives/form-field.directive.js'
import { MaybeAsyncPipe } from './pipes/maybe-async.pipe.js'
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component.js'
import { BaseChartDirective } from 'ng2-charts'
import { GenericTableColumn } from './components/generic-table/generic-table-column.directive.js'
import { TabGroupControlDirective } from './directives/tab-group-control.directive.js'
import { TabGroupTabControlDirective } from './directives/tab-group-tab-control-directive.js'
import { EscapeHtmlPipe } from './pipes/escape-html.pipe.js'
import { ReplaceNewlinesPipe } from './pipes/replace-newlines.pipe.js'
import { ImageSelectorComponent } from './components/image-selector/image-selector.component.js'
import { InlineCommentComponent } from './components/inline-comment/inline-comment.js'
import { TypeSafeMatCellDef } from './directives/typesafe-matcelldef.directive.js'
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component.js'
import { FilterByValuePipe } from './pipes/filter-by-value.pipe.js'
import { HasValidatorErrorPipe } from './pipes/has-validator-error.pipe.js'
import { FormCompomentForObjectDirective } from './directives/form-component-for-object.directive.js'
import { FormControlDestroyDirective } from './directives/form-control-destroy.directive.js'
import { ChatComponent } from './components/chat/chat.component.js'
import { LoginComponent } from './components/login/login.component.js'
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe.js'
import { Base64Pipe } from './pipes/base64.pipe.js'
import { NgxMatInputTelComponent } from 'ngx-mat-input-tel'
import { ReportComponent } from './components/report/report.component.js'
import { ArrayBufferSrcPipe } from './pipes/arraybuffer-src.pipe.js'

const Declarations = [
	// Components:
	ChatComponent,
	LoginComponent,
	DevBarComponent,
	FileUploadComponent,
	GenericPopupComponent,
	ImageSelectorComponent,
	ValidationErrorsComponent,
	GenericTableComponent,
	InlineCommentComponent,
	LanguageSwitcherComponent,
	RichTextEditorComponent,
	SearchableDropdownComponent,
	SnackBarComponent,
	// VideoComponent,
	// Pipes
	ArrayBufferSrcPipe,
	Base64Pipe,
	Base64SrcPipe,
	ConstPipe,
	EscapeHtmlPipe,
	FilterByValuePipe,
	HasValidatorErrorPipe,
	JsonHighlightPipe,
	MaybeAsyncPipe,
	ReplaceNewlinesPipe,
	SafeHtmlPipe,
	SafeResourceUrlPipe,
	SafeUrlPipe,
	SanitizeHtmlPipe,
	// FormBindingPipe,
	UntilChangedPipe,
	// Directives
	DynamicTabDirective,
	FormCompomentForObjectDirective,
	FormControlDestroyDirective,
	FormDirective,
	FormFieldDirective,
	GenericTableColumn,
	ScopeDirective,
	TabGroupControlDirective,
	TabGroupTabControlDirective,
	TypeSafeMatCellDef,
] as const

const ImportExport = [
	...MaterialModules,
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	// HttpClientModule,
	LetDirective,
	OverlayModule,
	AngularSplitModule,
	BaseChartDirective,
	NgxMatInputTelComponent,
	ReportComponent,
]

@NgModule({
	imports: [
		// SocketIoModule.forRoot({
		//   url: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
		//   options: {
		//     transports: ['websocket'],
		//   }
		// }),
		...ImportExport,
	],
	declarations: [...Declarations],
	exports: [...Declarations, ...ImportExport],
})
export class NgSharedModule {}
